import i18n from '@/internatinalization/i18n'
import store from '@/store'

export default function(
  httpError,
  genericErrorMessage = 'An unexpected error occurred'
) {
  console.log({ httpError })

  if (httpError.response) {
    if (
      httpError.response.status === 500 ||
      httpError.response.status === 404
    ) {
      store.dispatch(
        'notification/pushNotification',
        {
          type: 'error',
          messages: [
            httpError.response.status === 500
              ? i18n.t('server.server-error')
              : i18n.t('server.not-found')
          ]
        },
        { root: true }
      )
    } else {
      let { errors } = httpError.response.data
      store.dispatch(
        'notification/pushNotification',
        {
          type: 'error',
          messages: errors
        },
        { root: true }
      )
    }
  } else if (httpError.request) {
    store.dispatch(
      'notification/pushNotification',
      {
        type: 'error',
        messages: [i18n.t('server.no-response')]
      },
      { root: true }
    )
  } else {
    store.dispatch(
      'notification/pushNotification',
      {
        type: 'error',
        messages: [genericErrorMessage]
      },
      { root: true }
    )
  }

  console.log({ httpError })
}
